import { useAppContext } from 'hooks/useAppContext';
import { useGlobals } from '../useGlobals';
import { AmplitudeData } from './types';

const useAmplitude = () => {
  const {
    state: {
      deviceSize: { isDesktop },
    },
  } = useAppContext();

  const { amplitude } = useGlobals();
  const device = isDesktop ? 'desktop' : 'mobile';

  const sendAmplitude = (tag: string, data?: AmplitudeData) => {
    amplitude().logEvent(tag, { device, ...data });
  };

  return {
    sendAmplitude,
  };
};

export { useAmplitude };
